/* eslint-disable no-undef */
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-chained-backend';
import Locize from 'i18next-locize-backend';
import HTTP from 'i18next-http-backend';
import LocalStorageBackend from 'i18next-localstorage-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

const isDevelopment = process.env.NODE_ENV === 'development';

i18n
  .use(LanguageDetector)
  .use(Backend)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    supportedLngs: [
      'en',
      'ar',
      'at',
      'ca',
      'cs',
      'da',
      'de',
      'el',
      'en-US',
      'es',
      'es-MX',
      'fi',
      'fr',
      'hu',
      'id',
      'is',
      'it',
      'ja',
      'ko',
      'ms',
      'nb-NO',
      'nl',
      'pl',
      'pt',
      'pt-BR',
      'ro',
      'ru',
      'sv',
      'th',
      'tl',
      'tr',
      'uk',
      'vi',
      'zh-Hans',
      'zh-Hant',
    ],
    defaultNS: 'common',
    ns: [
      'common',
      'graphs',
      'projects',
      'playground',
      'history',
      'settings',
      'offset',
      'myOffset',
      'transactions',
      'paymentMethod',
      'signup',
      'marketingToolkit',
      'reduce',
      'onboarding',
      'onboardingConnect',
      'onboardingCorporate',
      'footprints',
    ],
    load: 'languageOnly',
    returnNull: false,
    returnEmptyString: false,
    debug: isDevelopment,
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
    backend: {
      backends: [
        LocalStorageBackend, // primary
        Locize, // primary
        HTTP, // fallback
      ],
      backendOptions: [
        {
          prefix: 'i18_',
          expirationTime: parseInt(process.env.REACT_APP_LOCIZE_EXPIRATION ?? '3600000'), // cache
        },
        {
          projectId: process.env.REACT_APP_LOCIZE_PROJECT_ID,
          apiKey: process.env.REACT_APP_LOCIZE_API_KEY,
          version: 'latest',
          failLoadingOnEmptyJSON: true,
        },
        {
          loadPath: '/locales/{{lng}}/{{ns}}.json', // xhr load path for my own fallback
        },
      ],
    },
  });

export default i18n;
